module.exports = __webpack_public_path__ + "ro.svg?488ee906d08b52610dfb7f47cb84f2e6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/ro.svg
// module id = 1332
// module chunks = 0